import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M873-391 570-88q-11 11-26 17-15 5-30 5t-29-5q-15-6-26-17L90-458q-11-11-18-25-6-15-6-30v-302q0-33 23-56 23-24 56-24h303q15 0 30 7 14 6 26 17l369 368q12 12 18 26 5 15 5 30t-6 30q-6 15-17 26ZM516-143l301-303-370-369H145v299l371 373ZM249-661q21 0 36-15t15-36q0-20-15-36t-35-15q-21 0-37 15-15 16-15 36t15 36q15 15 36 15Zm232 182Z"/>',
  f: '<path d="M873-391 570-88q-11 11-26 17-15 5-30 5t-29-5q-15-6-26-17L90-458q-11-11-18-25-6-15-6-30v-302q0-33 23-56 23-24 56-24h303q15 0 30 7 14 6 26 17l369 368q12 12 18 26 5 15 5 30t-6 30q-6 15-17 26ZM249-661q21 0 36-15t15-36q0-20-15-36t-35-15q-21 0-37 15-15 16-15 36t15 36q15 15 36 15Z"/>',
};

export default data;
